import { computed, ElementRef, Injectable, Signal, signal } from '@angular/core';
import { SwiperContainer } from 'swiper/element';
import { Swiper, SwiperOptions } from 'swiper/types';

@Injectable()
export class SwiperService {
  private swiperContainerSignal = signal<SwiperContainer | null>(null);

  private swiperInstance: Signal<Swiper | null> = computed(() => {
    const container = this.swiperContainerSignal();

    return container ? container.swiper : null;
  });

  constructor() {}

  async initializeSwiper(elNgComponentRef: ElementRef, initConfig: SwiperOptions): Promise<Swiper | null> {
    const swiperElement = elNgComponentRef.nativeElement.querySelector('swiper-container') as SwiperContainer;

    if (!swiperElement) {
      return null;
    }

    await customElements.whenDefined('swiper-container');

    if (typeof swiperElement.initialize !== 'function') {
      customElements.upgrade(swiperElement);
    }

    if (typeof swiperElement.initialize !== 'function') {
      await new Promise<void>((resolve) => requestAnimationFrame(() => resolve()));
    }

    if (typeof swiperElement.initialize !== 'function') {
      return null;
    }

    Object.assign(swiperElement, initConfig);
    swiperElement.initialize();
    this.swiperContainerSignal.set(swiperElement);

    return swiperElement.swiper;
  }

  updateSwiperConfig(config: SwiperOptions): void {
    const swiperContainer = this.swiperContainerSignal();
    if (swiperContainer) {
      Object.assign(swiperContainer, config);
    }
  }

  destroySwiper(): void {
    const swiperInstance = this.swiperInstance();
    if (swiperInstance) {
      swiperInstance.destroy();
      this.swiperContainerSignal.set(null);
    }
  }

  get swiper(): Swiper | null {
    return this.swiperInstance();
  }
}
